<template>
  <section class="home-view container">
    <Headline :size="1">
      Welcome back, {{ name }}!
    </Headline>

    <div class="cards-wrapper">
      <div class="cards-row">
        <Card
            v-if="$store.getters['user/haveAccessToAccreditation']"
            class="cards-item"
            :iconName="Icons.ACCREDITATION"
            title="Accreditation Request"
            @click="redirect('dashboard/request-accreditation')"
        />
        <Card
            v-if="$store.getters['user/haveAccessToTickets']"
            class="cards-item"
            :iconName="Icons.TICKET"
            title="Ticket Request"
            @click="redirectToNamedRoute(routerNames.IndexRoutes.DashboardRoutes.TicketRequest)"
        />
        <Card
            v-if="$store.getters['user/haveAccessToActivations']"
            class="cards-item"
            :iconName="Icons.PARTNER"
            title="Activation Request"
            @click="redirectToNamedRoute(routerNames.IndexRoutes.DashboardRoutes.SponsorActivation)"
        />
        <Card
            v-if="$store.getters['user/haveAccessToBroadcasterBooking']"
            class="cards-item"
            :iconName="Icons.RADAR"
            title="Broadcaster Booking"
            @click="openTabWithUrl($store.getters['user/getBroadcasterBookingUrl'])"
        />
        <Card
            v-if="$store.getters['user/haveAccessToBroadcasterSchedule']"
            class="cards-item"
            :iconName="Icons.CALENDER_CHECK_O"
            title="Broadcast Schedule"
            @click="openTabWithUrl($store.getters['user/getBroadcasterBookingUrl'])"
        />
        <Card
            v-if="$store.getters['user/haveAccessToApprovals']"
            class="cards-item"
            :iconName="Icons.APPROVAL"
            title="Approvals"
            @click="openTabWithUrl('https://theafg.sharepoint.com/sites/BrandInformationCentre46/')"
        />
        <Card
            v-if="$store.getters['user/haveAccessToBrandAccess']"
            class="cards-item"
            :iconName="Icons.BRAND_ASSETS"
            title="Brand & Information Centre"
            @click="openTabWithUrl('https://theafg.sharepoint.com/sites/BrandInformationCentre46/')"
        />
        <Card
            v-if="$store.getters['user/haveAccessToUnilateralProductionBookings']"
            class="cards-item"
            :iconName="Icons.TV_CAMERA"
            title="HB & Unilateral Production Services"
            @click="openTabWithUrl('https://www.cognitoforms.com/asiafootballmarketingfzllc')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import RouterNames from '@/router/route.names';
import Headline from '@/components/Headline/Headline.component'
import Card from '@/components/Card/Card.component'
import Icons from '@/components/Icon/Icon.list';

import get from "lodash.get";

export default {
  name: "Home",
  components: {
    Headline,
    Card
  },
  props: {
    imgUrl: String,
    text: String
  },
  computed: {
    name() {
      return get(this, '$store.state.user.model.name')
    },
    routerNames() {
      return RouterNames
    },
    Icons() {
      return Icons;
    }
  },

  methods: {
    redirect(path) {
      this.$router.push(path)
    },
    redirectToNamedRoute(name) {
      this.$router.push({name});
    },
    openTabWithUrl(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.home-view {
  padding: 0;

  .cards-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 20px;
  }

  .cards-item {
    margin-bottom: 20px;
    margin-right: 20px;
  }

  .cards-dummy {
    display: block;
    width: 220px;
    height: 0;
  }

  ::v-deep .paragraph-component {
    padding: 0;
  }
}
</style>
